import { render } from "./SubchannelsMenu.vue?vue&type=template&id=43682ee8"
import script from "./SubchannelsMenu.vue?vue&type=script&lang=js"
export * from "./SubchannelsMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__